<fgb-navigation-indicator></fgb-navigation-indicator>

<ng-container *ngIf="!navigationSettings?.desktop.hidden">
  <fgb-nav-bar *ifScreenSize="screenType.Desktop"></fgb-nav-bar>
</ng-container>

<fgbcl-notification-toast></fgbcl-notification-toast>

<div id="main" role="main" class="bg-black">
  <router-outlet></router-outlet>
</div>

<fgb-footer></fgb-footer>
